import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import { useClickAway } from 'react-use';
import Link from 'components/consumer/Link';
import MenuButton from 'components/consumer/menu-button';
import IconUserAccount from 'components/icons/iconUserAccount';
import IconSearch from 'components/icons/IconSearch';
import IconMapMarker from 'components/icons/IconMapMarker';
import LogoLink from 'components/consumer/LogoLink';
import { colorGrayLight1 } from 'styles/layout/colors';
import avo from 'analytics/avo';
import MobileNavbarModalUI from 'components/nav/MobileNavbarModal/MobileNavbarModalUI';
import useIsBrowser from 'hooks/useIsBrowser';
import useUserData from 'data-hooks/useUserData';
import MobileNavbarShowroomLocator from 'components/nav/shared/HeaderToolbar/MobileNavbarShowroomLocator';
import IcCart from './ic-cart';
import InstantSearchMobile from '../consumer-search/instant-search/InstantSearchMobile';
import BrowserOnly from '../BrowserOnly';
const ConsumerHeaderMobile = () => {
  const $ = _c(47);
  const isBrowser = useIsBrowser();
  const targetElement = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileSearchBarOpen, setIsMobileSearchBarOpen] = useState(false);
  const [isShowroomLocatorOpen, setIsShowroomLocatorOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const {
    isLoggedIn
  } = useUserData();
  const showroomDropdownRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = t1 => {
      const {
        searchQuery: updatedSearchQuery,
        currentPage: updatedCurrentPage
      } = t1;
      setSearchQuery(updatedSearchQuery);
      setCurrentPage(updatedCurrentPage);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setSearchEventParams = t0;
  let t1;
  if ($[1] !== currentPage || $[2] !== isMenuOpen || $[3] !== searchQuery) {
    t1 = () => {
      if (isMenuOpen === true && searchQuery?.length > 1 && currentPage) {
        avo.productsSearched({
          query: searchQuery,
          location: currentPage,
          searchTarget: avo.SearchTarget.EXIT_SEARCH
        });
      }
    };
    $[1] = currentPage;
    $[2] = isMenuOpen;
    $[3] = searchQuery;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const logSearchToAvo = t1;
  let t2;
  if ($[5] !== logSearchToAvo) {
    t2 = () => {
      logSearchToAvo();
      setIsMenuOpen(_temp);
    };
    $[5] = logSearchToAvo;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const toggleMenu = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsShowroomLocatorOpen(false);
      setIsMobileSearchBarOpen(_temp2);
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const toggleSearchBar = t3;
  let t4;
  if ($[8] !== logSearchToAvo) {
    t4 = () => {
      logSearchToAvo();
      setIsMenuOpen(false);
      setSearchQuery(null);
      setCurrentPage(null);
    };
    $[8] = logSearchToAvo;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const closeMenu = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsMobileSearchBarOpen(false);
      setIsShowroomLocatorOpen(_temp3);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const toggleShowroomLocator = t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsShowroomLocatorOpen(false);
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const closeShowroomLocator = t6;
  useClickAway(showroomDropdownRef, closeShowroomLocator);
  let t7;
  if ($[12] !== isMenuOpen) {
    t7 = classNames("h-[3.75rem] w-full hidden z-[998] [-webkit-tap-highlight-color:transparent] max-[1023px]:[transition:transform_1s_ease-in] max-[1023px]:block", "[&_a]:no-underline [&_a]:text-gray", {
      expanded: isMenuOpen
    });
    $[12] = isMenuOpen;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isMenuOpen || $[15] !== toggleMenu) {
    t8 = <div className="items-center flex h-full justify-center left-0 absolute top-0 w-[60px] rounded-[2rem] z-[1] hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7"><MenuButton onClick={toggleMenu} open={isMenuOpen} /></div>;
    $[14] = isMenuOpen;
    $[15] = toggleMenu;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LogoLink className="hover:bg-gray-light7" />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="cursor-pointer bg-white rounded-[2rem] box-border w-12 h-12 flex justify-center items-center relative hover:z-10 active:z-10 focus-within:z-10 hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7 [&_a]:flex"><button data-xc="search" title="Search" className="[background:none] border-0 focus-visible:outline-offset-4" type="button" onClick={toggleSearchBar}><IconSearch color={colorGrayLight1} height="17" width="17" /></button></div>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="cursor-pointer bg-white rounded-[2rem] box-border w-12 h-12 flex justify-center items-center relative hover:z-10 active:z-10 focus-within:z-10 hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7 [&_a]:flex"><button type="button" onClick={toggleShowroomLocator} className="[background:none] border-0 focus-visible:outline-offset-4" title="Showrooms"><IconMapMarker color={colorGrayLight1} height="19" width="19" className="[&_svg_path]:!stroke-[1]" /></button></div>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isShowroomLocatorOpen) {
    t12 = isShowroomLocatorOpen && <div className="absolute top-full -right-16 mt-1 bg-white border border-gray-light5 z-[1000]"><MobileNavbarShowroomLocator onClose={() => setIsShowroomLocatorOpen(false)} /></div>;
    $[20] = isShowroomLocatorOpen;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <div ref={showroomDropdownRef} className="relative">{t11}{t12}</div>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = isLoggedIn && isBrowser ? "/customer/dashboard/" : "/sign-in/";
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconUserAccount />;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t14) {
    t16 = <div className="cursor-pointer bg-white rounded-[2rem] box-border w-12 h-12 flex justify-center items-center relative hover:z-10 active:z-10 focus-within:z-10 hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7 [&_a]:flex"><Link to={t14} className="[background:none] border-0 focus-visible:outline-offset-4">{t15}</Link></div>;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IcCart isMobile={true} isFixedTopNav={true} />;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t13 || $[29] !== t16) {
    t18 = <div className="absolute right-5 flex items-center justify-end -space-x-3">{t10}{t13}{t16}{t17}</div>;
    $[28] = t13;
    $[29] = t16;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18 || $[32] !== t8) {
    t19 = <div className="relative items-center justify-center h-[3.75rem] w-full px-[3.333vw] py-0 z-[999] max-[1023px]:bg-white max-[1023px]:flex max-[1023px]:[transition:transform_.25s_ease-in-out,background-color_.25s_ease-in-out] max-[1023px]:px-5 max-[1023px]:py-0 hover:max-[1023px]:[border-bottom:none]">{t8}{t9}{t18}</div>;
    $[31] = t18;
    $[32] = t8;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== closeMenu || $[35] !== isMobileSearchBarOpen) {
    t20 = isMobileSearchBarOpen && <div className="relative items-center justify-center h-[3.75rem] w-full z-[999] max-[1023px]:bg-white max-[1023px]:[transition:transform_.25s_ease-in-out,background-color_.25s_ease-in-out]"><InstantSearchMobile placeholder="Search Joybird" toggleMenu={closeMenu} setSearchEventParams={setSearchEventParams} variant="consumer-header-mobile" toggleMobileSearchBar={toggleSearchBar} /></div>;
    $[34] = closeMenu;
    $[35] = isMobileSearchBarOpen;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t20) {
    t21 = <BrowserOnly>{t20}</BrowserOnly>;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== closeMenu || $[40] !== isMenuOpen) {
    t22 = <BrowserOnly><MobileNavbarModalUI isOpen={isMenuOpen} onClose={closeMenu} /></BrowserOnly>;
    $[39] = closeMenu;
    $[40] = isMenuOpen;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t19 || $[43] !== t21 || $[44] !== t22 || $[45] !== t7) {
    t23 = <div className={t7} ref={targetElement}>{t19}{t21}{t22}</div>;
    $[42] = t19;
    $[43] = t21;
    $[44] = t22;
    $[45] = t7;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
};
export default ConsumerHeaderMobile;
function _temp(prevMenu) {
  return !prevMenu;
}
function _temp2(prevVal) {
  return !prevVal;
}
function _temp3(prev) {
  return !prev;
}